import { Helpers } from "../jobs-flow/Helpers";

export default {
    timeout:null,

    init(){
        $('body').off('click', '#copyCode').on('click', '#copyCode', () => {
            Helpers.selectElementContents($('#snippetCode')[0]);
            $('#codeCopyMessage').css('z-index',100).css('opacity', 1);
            setTimeout(()=>{
                $('#codeCopyMessage').css('opacity', 0)
                setTimeout(()=>$('#codeCopyMessage').css('z-index', -100),300)
            },2500)
        });
        $('body').off('click', '#add-gtm').on('click', '#add-gtm', (ev)=>{
            $.ajax({
                method: 'POST',
                url: `/${$(ev.currentTarget).data('entity')}/settings/snippet-integration/insert-gtm-code`,
                data: {
                    gtm_code: $('#gtm-code').val(),
                    type:$(ev.currentTarget).data('type')
                },
                success: (response) => this.showGtmResult(response?.success),
                error: () => this.showGtmResult(false)
            });
        });
    },

    showGtmResult(success){
        clearTimeout(this.timeout)
        this.timeout = setTimeout(()=>$('#gtm-result').addClass('d-none'), 2000)
        if(success)
            $('#gtm-result').text('Successfully saved!').css('color','')
        else
            $('#gtm-result').text('Saving error!').css('color','#DB3A57')
        $('#gtm-result').removeClass('d-none')
    }
}

